export default function RecommendationCategoriesDirective() {
  return {
    template: require('./recommendation-categories.html'),
    scope: {
      auditId: '=',
      customerId: '=',
      coordinatorId: '=',
      auditPackageId: '=',
      hasActiveAuditPackage: '=',
      hasAuditPackageGenerationRequests: '=',
      auditIsActive: '=',
      canEdit: '=',
      canGeneratePackage: '=',
      canDownloadPackage: '=',
    },
    controller: 'RecommendationCategoriesController',
    controllerAs: 'recommendationCategoriesVM',

    bindToController: true,
    replace: true
  };
}
